(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-addon"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof addAnimationToElements === 'function') {
      addAnimationToElements({
        selector: '[data-animate-selector="spec-container"]',
        animateName: 'fade-in-bottom',
        initialStateName: 'fade-in-bottom',
        interval: 500
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shd-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqs = document.querySelectorAll('.faq');

    faqs.forEach(function (faq) {
      faq.addEventListener('click', function () {
        const questionContainer = faq.querySelector('.question-container');
        const iconContainer = faq.querySelector('.icon-container img');

        // Remove active-faq class from all other FAQs
        faqs.forEach(function (otherFaq) {
          const otherQuestionContainer = otherFaq.querySelector('.question-container');
          const otherIconContainer = otherFaq.querySelector('.icon-container img');

          if (otherQuestionContainer !== questionContainer) {
            otherQuestionContainer.classList.remove('active-faq');
            if (otherIconContainer) {
              otherIconContainer.classList.remove('rotate-icon');
            }
          }
        });

        // Toggle the active class for the clicked FAQ
        questionContainer.classList.toggle('active-faq');

        if (iconContainer) {
          iconContainer.classList.toggle('rotate-icon');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shd-hero-section-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCopyText(scope) {
      scope = scope || document;
      var links = scope.querySelectorAll('[class*="extra-text-container-"] a[href*="#copy"]');
      links.forEach(function (link) {
        if (link.dataset.copyReady) return;

        var span = document.createElement('span');
        span.className = 'shd-copy-text';
        span.setAttribute('role', 'button');
        span.setAttribute('tabindex', '0');
        span.dataset.copyReady = 'true';
        span.innerHTML = link.innerHTML;
        link.replaceWith(span);

        function copy() {
          navigator.clipboard.writeText(span.textContent.trim()).then(function () {
            span.classList.add('is-copied');
            setTimeout(function () { span.classList.remove('is-copied'); }, 1500);
          });
        }

        span.addEventListener('click', copy);
        span.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copy(); }
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () { initCopyText(); });
    // Re-inicializa quando o bloco é editado no theme editor
    document.addEventListener('shopify:section:load', function (e) { initCopyText(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shd-show-products-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    addAnimationToElements({
      selector: '[data-animate-selector="product-column"]',
      animateName: 'fade-in-bottom',
      initialStateName: 'fade-in-bottom',
      interval: 500,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shd-show-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    addAnimationToElements({
      selector: '[data-animate-selector="product-column"]',
      animateName: 'fade-in-bottom',
      initialStateName: 'fade-in-bottom',
      interval: 500,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shd-spec-two"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // ── Entrance animations ──
    addAnimationToElements({
      selector: '[data-animate-selector="spec-container"]',
      animateName: 'fade-in-bottom',
      initialStateName: 'fade-in-bottom',
      interval: 500
    });
  });

  } catch(e) { console.error(e); }
})();
})();
